import React from 'react';
import { convertIcon, IconSize } from '../component/Icon';

function SvgComponent(props: React.SVGProps<SVGSVGElement> & IconSize) {
  return (
    <svg
      width="210"
      height="30"
      viewBox="0 0 210 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2783_8489)">
        <path
          d="M0 29.1682H4.92912V17.7358C4.92912 14.7454 6.34368 12.847 9.57432 12.847C12.805 12.847 14.2195 14.7454 14.2195 17.7358V29.1698H19.1486V17.8164C19.1486 11.8776 15.5938 8.24208 9.57432 8.24208C3.55488 8.24208 0 11.8776 0 17.8164V29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M190.85 29.1682H195.779V17.7358C195.779 14.7454 197.193 12.847 200.424 12.847C203.655 12.847 205.069 14.7454 205.069 17.7358V29.1698H209.998V17.8164C209.998 11.8776 206.443 8.24208 200.424 8.24208C194.405 8.24208 190.85 11.8776 190.85 17.8164V29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M177.316 29.1682H182.245V15.1906C182.245 14.0599 182.69 13.655 183.538 13.655H189.437V8.96783H183.012C179.417 8.96783 177.316 10.3824 177.316 14.6244V29.1682V29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M164.065 8.24208C157.844 8.24208 153.439 12.847 153.439 19.0697C153.439 25.2924 157.843 29.857 164.065 29.857C170.288 29.857 174.732 25.2924 174.732 19.0697C174.732 12.847 170.288 8.24208 164.065 8.24208V8.24208ZM164.065 25.0488C160.793 25.0488 158.369 22.5842 158.369 19.0697C158.369 15.5551 160.793 13.0502 164.065 13.0502C167.338 13.0502 169.803 15.5551 169.803 19.0697C169.803 22.5842 167.378 25.0488 164.065 25.0488Z"
          fill="#FEFEFE"
        />
        <path
          d="M125.968 6.54528C127.584 6.54528 129.2 5.13072 129.2 3.23232C129.2 1.45488 127.665 0 125.968 0C124.271 0 122.736 1.45488 122.736 3.23232C122.736 5.00976 124.191 6.54528 125.968 6.54528Z"
          fill="#00E4DF"
        />
        <path
          d="M141.602 29.8553C146.612 29.8553 150.572 26.7036 151.541 21.7342H146.41C145.925 23.7938 144.026 25.0471 141.602 25.0471C138.249 25.0471 135.905 22.5826 135.905 19.068C135.905 15.5534 138.249 13.0486 141.602 13.0486C143.784 13.0486 145.764 14.2195 146.41 16.2002H151.501C150.773 11.4727 146.693 8.24208 141.602 8.24208C135.381 8.24208 130.976 12.8066 130.976 19.0697C130.976 25.3327 135.379 29.857 141.602 29.857V29.8553Z"
          fill="#FEFEFE"
        />
        <path d="M128.392 8.96953H123.463V29.1698H128.392V8.96953Z" fill="#FEFEFE" />
        <path
          d="M101.405 29.1682H106.334V17.7358C106.334 14.7454 107.748 12.847 110.979 12.847C114.21 12.847 115.624 14.7454 115.624 17.7358V29.1698H120.553V17.8164C120.553 11.8776 116.999 8.24208 110.979 8.24208C104.96 8.24208 101.405 11.8776 101.405 17.8164V29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M89.4466 29.8956C95.7482 29.8956 99.0209 26.1391 99.0209 20.8454V8.96953H94.0918V20.281C94.0918 23.352 92.4353 25.2101 89.4046 25.2101C86.3738 25.2101 84.7997 23.352 84.7997 20.281V8.96953H79.8706V20.8471C79.8706 26.1391 83.1835 29.8973 89.4449 29.8973L89.4466 29.8956Z"
          fill="#FEFEFE"
        />
        <path
          d="M71.6302 29.1682H77.4883V24.481H72.2366C71.3882 24.481 70.943 23.7938 70.943 22.9858V13.5727H77.285V8.96784H70.943V2.3436L66.0139 5.292V22.5826C66.0139 27.673 68.1139 29.1682 71.6302 29.1682V29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M42.7022 29.1682H48.3991L53.4089 22.0987L58.5799 29.1682H64.3978L56.7218 18.7858L63.9542 8.96953H58.0961L53.5702 15.4325L48.804 8.96953H42.9862L50.2169 18.7858L42.7022 29.1682Z"
          fill="#FEFEFE"
        />
        <path
          d="M32.2795 8.24208C26.0182 8.24208 21.6132 13.0502 21.6132 18.8261C21.6132 25.1278 26.4214 29.8956 32.2795 29.8956C37.0877 29.8956 41.2894 27.2698 42.6216 22.4213H37.7731C37.086 24.2794 35.107 25.4117 32.3602 25.4117C29.6134 25.4117 26.8666 23.5133 26.5826 20.7245H42.8635C44.0345 14.1792 39.3086 8.2404 32.2778 8.2404L32.2795 8.24208ZM26.8666 16.6858C27.4327 14.3825 29.4924 12.726 32.3198 12.726C35.1473 12.726 37.2893 14.2615 37.8554 16.6858H26.8666Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_2783_8489">
          <rect width="210" height="29.8956" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const IconComponent = convertIcon(SvgComponent, 'logo-next-unicorn-white-long');
export default IconComponent;
